/* Product customiser: live card preview, finish switch, flip, tilt, dropzone. */
(function () {
  var root = document.querySelector('[data-pdp]');
  if (!root) return;
  var pv = root.querySelector('.pv'), card = pv.querySelector('.ntc'), stage = pv.querySelector('.pv__stage');
  var q = function (s) { return root.querySelector(s); };
  var qa = function (s) { return [].slice.call(root.querySelectorAll(s)); };

  // live text binding
  qa('[data-bind]').forEach(function (inp) {
    var key = inp.dataset.bind, out = qa('[data-out="' + key + '"]'), cnt = q('[data-count-for="' + key + '"]');
    var sync = function () {
      var v = inp.value.trim();
      out.forEach(function (o) { o.textContent = v || o.dataset.empty; o.classList.toggle('is-empty', !v); });
      if (cnt) cnt.textContent = inp.value.length + '/' + inp.maxLength;
      if (v && pv.classList.contains('is-back')) setSide(false);
    };
    inp.addEventListener('input', sync); sync();
  });

  // finish (body colour)
  var setFinish = function (el) {
    ['--c-a', '--c-b', '--c-hi'].forEach(function (k) { card.style.setProperty(k, el.dataset[k.slice(2).replace('-', '')]); });
    card.classList.toggle('ntc--bamboo', el.dataset.material === 'bamboo');
  };
  qa('input[name="properties[Gövde]"]').forEach(function (r) {
    r.addEventListener('change', function () { if (r.checked) setFinish(r); });
  });
  var want = new URLSearchParams(location.search).get('govde');
  var pre = qa('input[name="properties[Gövde]"]').filter(function (r) { return want && r.value === want; })[0] || q('input[name="properties[Gövde]"]:checked');
  if (pre) { pre.checked = true; setFinish(pre); }

  // front / back
  var rx = 0, ry = 0, back = false;
  var apply = function () { card.style.transform = 'rotateX(' + rx + 'deg) rotateY(' + (ry + (back ? 180 : 0)) + 'deg)'; };
  function setSide(b) {
    back = b; pv.classList.toggle('is-back', b);
    qa('[data-side]').forEach(function (btn) { btn.setAttribute('aria-pressed', String((btn.dataset.side === 'back') === b)); });
    apply();
  }
  qa('[data-side]').forEach(function (btn) { btn.addEventListener('click', function () { setSide(btn.dataset.side === 'back'); }); });

  // hover tilt
  if (matchMedia('(pointer:fine)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    stage.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      rx = -y * 14; ry = x * 18;
      card.style.transition = 'transform .25s ease-out';
      card.style.setProperty('--shx', (x * 80) + '%');
      [].forEach.call(card.querySelectorAll('.ntc__face'), function (f) { f.style.setProperty('--shx', (x * 80) + '%'); });
      apply();
    });
    stage.addEventListener('pointerleave', function () { rx = 0; ry = 0; card.style.transition = ''; apply(); });
  }

  // dropzone
  var dz = q('.dz'), file = dz.querySelector('input[type=file]'), err = q('.dz__err');
  var logoSlot = q('[data-out="logo"]'), logoText = logoSlot ? logoSlot.textContent : '';
  var MAX = 20 * 1024 * 1024;
  var fmt = function (b) { return b > 1048576 ? (b / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(b / 1024)) + ' KB'; };
  var clear = function () {
    file.value = ''; dz.classList.remove('has-file');
    logoSlot.classList.remove('has-img'); logoSlot.textContent = logoText;
    q('.dz__thumb').style.backgroundImage = ''; q('.dz__thumb').textContent = '';
  };
  var show = function (f) {
    err.classList.remove('on');
    if (!f) return clear();
    if (f.size > MAX) { err.textContent = 'Dosya 20 MB sınırını aşıyor.'; err.classList.add('on'); return clear(); }
    dz.classList.add('has-file');
    q('.dz__meta b').textContent = f.name;
    q('.dz__meta span').textContent = fmt(f.size) + (/^image\//.test(f.type) ? ' · Kartta önizleniyor' : ' · Baskı ekibine iletilecek');
    var th = q('.dz__thumb');
    if (/^image\//.test(f.type)) {
      var rd = new FileReader();
      rd.onload = function () {
        th.style.backgroundImage = 'url("' + rd.result + '")'; th.textContent = '';
        logoSlot.innerHTML = ''; var im = new Image(); im.alt = 'Logonuz'; im.src = rd.result;
        logoSlot.appendChild(im); logoSlot.classList.add('has-img');
        setSide(false);
      };
      rd.readAsDataURL(f);
    } else {
      th.style.backgroundImage = ''; th.textContent = (f.name.split('.').pop() || '').toUpperCase();
      logoSlot.classList.remove('has-img'); logoSlot.textContent = logoText;
    }
  };
  file.addEventListener('change', function () { show(file.files[0]); });
  ['dragenter', 'dragover'].forEach(function (ev) { dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.add('is-over'); }); });
  ['dragleave', 'drop'].forEach(function (ev) { dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.remove('is-over'); }); });
  dz.addEventListener('drop', function (e) {
    var f = e.dataTransfer.files[0]; if (!f) return;
    try { var dt = new DataTransfer(); dt.items.add(f); file.files = dt.files; } catch (x) {}
    show(f);
  });
  q('.dz__x').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); clear(); });

  // quantity
  var qty = q('.qty input');
  qa('.qty button').forEach(function (b) {
    b.addEventListener('click', function () { qty.value = Math.max(1, (+qty.value || 1) + (+b.dataset.step)); });
  });
})();
